<template>
  <transition name="el-zoom-in-center">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content-noneheader">
        <!-- Default box -->
        <div class="box">
          <div class="box-header">
            <div class="box-header with-border">
              <el-breadcrumb separator="/" v-if="this.$route.query.customerId != null">
                <el-breadcrumb-item>客户管理</el-breadcrumb-item>
                <el-breadcrumb-item :to="{path: '/customer/customerEmpList'}">我的客户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{path: '/memo/systemMemoList', query: {customerId: this.$route.query.customerId}}">服务提醒</el-breadcrumb-item>
                <el-breadcrumb-item>录入</el-breadcrumb-item>
              </el-breadcrumb>

              <el-breadcrumb separator="/" v-else>
                <el-breadcrumb-item>客户管理</el-breadcrumb-item>
                <el-breadcrumb-item :to="{path: '/memo/systemMemoList'}">服务提醒</el-breadcrumb-item>
                <el-breadcrumb-item>录入</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>
          <div class="box-body">
            <div style="width: auto; text-align: center">
              <!-- 详细样式参考 http://element-cn.eleme.io/#/zh-CN/component/form -->
              <el-form ref="form" :model="vo" :rules="rules" label-width="100px" class="form-default">
                <el-form-item label="客户" prop="customerInfo">
                  <el-input placeholder="请选择客户" v-model="vo.customerInfo.name" :readonly="true"
                            class="input-with-select">
                    <template v-if="!customerId">
                      <el-button slot="append" icon="el-icon-search" @click="handlePopRefBtnClick"></el-button>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item label="用户" prop="toUser">
                  <el-input v-model="vo.toUser.name" :readonly="true" class="input-with-select">
                  </el-input>
                </el-form-item>
                <el-tabs tab-position="left" style="height: 200px;" @tab-click="onTabClick">
                  <el-tab-pane id="dateRange" label="日期范围">
                    <el-form-item label="日期范围" prop="dateRange">
                      <el-date-picker
                        v-model="vo.dateRange"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        style="width: 100%">
                      </el-date-picker>
                    </el-form-item>
                  </el-tab-pane>
                  <el-tab-pane id="loop" label="周期循环">
                    <el-form-item label="开始日期">
                      <el-date-picker v-model="vo.beginAt" type="date" align="right" placeholder="开始日期" />
                    </el-form-item>
                    <el-form-item label="重复间隔">
                      <el-input v-model.number="vo.loopInterval" placeholder="请输入重复间隔（天数）" class="input-size-200 input-margin-right"></el-input>
                    </el-form-item>
                  </el-tab-pane>
                </el-tabs>
                <el-form-item label="备注" prop="remark">
                  <el-input v-model="vo.remark"></el-input>
                </el-form-item>
                <hr style="margin:1rem 0rem;">
                <el-form-item>
                  <el-button type="primary" @click="onSubmit">提交</el-button>
                  <el-button @click="onCancel">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </section>
      <!-- 选择用户弹出框 -->
      <el-dialog title="选择用户" :visible.sync="popRefCustomerInfo">
        <div class="search-div">
          <el-input v-model="infoName" placeholder="请输入客户姓名" class="input-size-200 input-margin-right"></el-input>
          <el-input v-model="infoCustomerNum" placeholder="请输入客户编号"
                    class="input-size-200 input-margin-right"></el-input>
          <el-input v-model="userName" placeholder="请输入系统用户昵称" class="input-size-200 input-margin-right"></el-input>
          <el-button type="primary" icon="el-icon-search" class="button-pull-right" @click="infoListSearch()">搜索
          </el-button>
          <br/>
        </div>
        <el-table
          ref="multipleTable" :data="dt.data" :stripe="true" border
          highlight-current-row style="width: 100%" size="mini"
          :size="dt.size"
          @sort-change="dt.handleSortChange"
          @selection-change="dt.handleSelectionChange"
        >
          <el-table-column type="selection" min-width=5%></el-table-column>
          <el-table-column property="id" label="ID" min-width=5%></el-table-column>
          <el-table-column property="name" label="名称" min-width=10% sortable="custom"></el-table-column>
          <el-table-column property="customerNum" label="客户编号" min-width=10% sortable="custom"></el-table-column>
          <el-table-column property="user.name" label="系统用户昵称" min-width=10% sortable="custom"></el-table-column>
          <el-table-column label="操作" min-width=20%>
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleInfoChoice(scope.$index, scope.row)">选择
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="dt.handleSizeChange"
          @current-change="dt.handleCurrentChange"
          :current-page="dt.currentPage"
          :page-sizes="dt.pageSizes"
          :page-size="dt.pageSize"
          :layout="dt.layout"
          :total="dt.totalElements">
        </el-pagination>
        <!--/.选择用户弹出框-->
      </el-dialog>
      <!-- /.content -->
    </div>
  </transition>
</template>

<script>
  import {DataTable} from "../../../data-table";
  import {CommonUtil} from "../../../global";
  import {SystemMemoService} from "../../../system-memo-service";

  export default {
    name: "SystemMemoModify",
    data: function () {
      let that = this;
      //  校验相关
      let infoValidate = (rule, value, callback) => {
        setTimeout(() => {
          let vo = this.vo;
          if (!vo.customerInfo || !vo.customerInfo.id || vo.customerInfo.id <= 0) {
            callback(new Error('请选择客户'));
          } else {
            callback();
          }
        }, 1000);
      };
      return {
        id: null,
        customerId: null, // 区分是我的客户模式 还是 通用管理模式
        customer: null,
        //  用户弹出选择框相关
        popRefCustomerInfo: false,
        dt: DataTable.getInstance(that, '/admin/customerInfo/findPage', "SystemMemoModify_"), // 客户列表
        infoName: "",
        userName: "",
        infoCustomerNum: "",
        vo: {
          customerInfo: {name: null},
          toUser: {name: null},
          beginAt: null,
          endAt: null,
          dateRange: null,
          loopType: false,
          loopInterval: null,
          remark: '服务提醒'
        },
        //  日期范围快捷选项
        pickerOptions: CommonUtil.dateRangePickerOptions(),
        rules: {
          customerInfo: [
            {validator: infoValidate, trigger: "change"}
          ],
          remark: [
            {required: true, message: '请输入', trigger: "change"},
            {max: 200, message: '长度不能超过200字符', trigger: "change"}
          ]
        }
      }
    },
    // （增加动态参数要在这里接收）
    mounted: function () {
      let queryMap = this.$route.query;
      // 区分是我的客户模式 还是 通用管理模式
      this.customerId = queryMap.customerId;
      if (this.customerId) { // 我的客户模式
        this.axios.get('/admin/customerInfo/find', {params: {id: this.customerId}})
          .then(resp => { // 装载对象
            if (resp.data && resp.data.code === 200) {
              this.customer = resp.data.data;
              this.initDomain(queryMap.id);
            } else {
              this.$router.push({path: '/memo/systemMemoList', query: {customerId: this.customerId}});
              this.$message({
                type: 'error',
                message: "查询失败"
              })
            }
          }).catch(resp => {
          this.$router.push({path: '/memo/systemMemoList', query: {customerId: this.customerId}});
          this.$message({
            type: 'error',
            message: "请求服务器出错"
          })
        })
      } else { // 通用管理模式
        this.initDomain(queryMap.id);
      }
    },
    methods: {
      // 初始化编辑对象
      initDomain: function (id) {
        // 区分新增还是编辑
        if (id) {
          this.id = id;
          //  向后台查询数据
          this.queryPageData(this.id);
        } else {
          this.id = null;
          if (this.customer) { // 我的客户模式 指定了具体客户
            this.vo.customerInfo = this.customer;
            if (this.customer.user) {
              this.vo.toUser = this.customer.user;
            }
          }
        }
      },
      // 向后台查询数据
      queryPageData: function (id) {
        this.axios.post('/admin/systemMemo/find', [], {params: {id: id}})
          .then(resp => { // 装载对象
            if (resp.data && resp.data.code === 200) {
              this.vo = resp.data.data;
              if (this.vo.toUser == null) {
                this.vo.toUser = {name: null}
              }
            } else {
              this.$router.push({path: '/memo/systemMemoList', query: {customerId: this.customerId}});
              this.$message({
                type: 'error',
                message: "查询失败"
              })
            }
          }).catch(resp => {
          this.$router.push({path: '/memo/systemMemoList', query: {customerId: this.customerId}});
          this.$message({
            type: 'error',
            message: "请求服务器出错"
          })
        })
      },
      //  关联客户查询
      infoListSearch: function () {
        var key = {};
        let filter = [];
        if (this.userName !== '') {
          key.name = 'user.name'
          key.value = this.userName
          key.type = 'string'
          filter.push(key)
        }
        if (this.infoName !== '') {
          key.name = 'name'
          key.value = this.infoName
          key.type = 'string'
          filter.push(key)
        }
        if (this.infoCustomerNum !== '') {
          key.name = 'customerNum'
          key.value = this.infoCustomerNum
          key.type = 'string'
          filter.push(key)
        }
        this.dt.filters = filter;
        //  向后台查询数据
        this.dt.queryPageData()
      },
      // 处理关联用户按钮被点击
      handlePopRefBtnClick: function () {
        //  还原过滤设置
        let filters = this.dt.filters;
        if (filters != null && filters instanceof Array) {
          for (let i = 0; i < filters.length; i++) {
            let f = filters[i];
            switch (f.name) {
              case "name":
                this.infoName = f.value;
                continue;
              case "customerNum":
                this.infoCustomerNum = f.value;
                continue;
              case "user.name":
                this.userName = f.value;
                continue;
            }
          }
        }
        this.popRefCustomerInfo = true;
        //  向后台查询数据
        this.dt.queryPageData();
      },
      //  处理用户弹出框选择
      handleInfoChoice: function (index, row) {
        if (row) {
          this.vo.customerInfo = row;
          if (row.user) {
            this.vo.toUser = row.user;
          } else {
            this.vo.toUser = {name: null};
          }
        } else {
          this.vo.customerInfo = {name: null};
          this.vo.toUser = {name: null};
        }
        this.popRefCustomerInfo = false;
      },
      onSubmit: function () {
        let that = this;
        // 检查录入的内容
        this.$refs['form'].validate((valid) => {
          if (valid) {
            let vo = that.vo;
            if (vo.customerInfo == null || vo.customerInfo.name == null) {
              that.$message({
                type: 'error',
                message: '请选择服务提醒的目标客户'
              });
              return false;
            }
            console.log("loopType", vo.loopType);
            if (vo.loopType) {
              if (vo.beginAt == null) {
                that.$message({
                  type: 'error',
                  message: '请选择开始日期'
                });
                return false;
              }
              if (vo.loopInterval == null || vo.loopInterval < 1) {
                that.$message({
                  type: 'error',
                  message: '请输入大于0的重复间隔'
                });
                return false;
              }
              vo.dateRange = null;
              vo.endAt = null;
            } else {
              if (vo.dateRange == null || vo.dateRange.length < 2) {
                that.$message({
                  type: 'error',
                  message: '请选择日期范围'
                });
                return false;
              }
              vo.loopInterval = null;
              vo.beginAt = null;
            }
            that.axios.post('/admin/systemMemo/save', vo).then(resp => {
              // console.log(vo);
              if (resp.data && resp.data.code === 200) {
                that.$message({
                  type: 'success',
                  message: '添加成功!'
                })
                SystemMemoService.getInstance(this).refresh(); // 刷新备忘列表
                that.$router.push({path: '/memo/systemMemoList', query: {customerId: that.customerId}});
              } else {
                that.$message({
                  type: 'error',
                  message: resp.data.message
                })
              }
            }).catch(resp => {
              that.$message({
                type: 'error',
                message: resp.data.message
              })
            });
          } else {
            return false;
          }
        });
      },
      onCancel: function () {
        this.$router.push({path: '/memo/systemMemoList', query: {customerId: this.customerId}});
      },
      onTabClick: function (tab) {
        this.vo.loopType = ((tab.index === 1) || (tab.index === "1"));
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// SystemMemoModify.vue?17a8e238